import { createContext, useContext, type ReactNode } from 'react';
import type { ThemeConfig } from './types';
import { defaultTheme } from './defaultTheme';

const ThemeContext = createContext<ThemeConfig>(defaultTheme);

export function ThemeProvider({
  theme = defaultTheme,
  children,
}: {
  theme?: ThemeConfig;
  children: ReactNode;
}) {
  return (
    <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
  );
}

export function useTheme(): ThemeConfig {
  return useContext(ThemeContext);
}
